module.exports = __webpack_public_path__ + "assets/img/flamengo4.d07b233c.png";